/** @jsx h */
// eslint-disable-next-line no-unused-vars
import { h, Component, Fragment } from 'preact';
import { useState, useRef, useEffect } from 'preact/hooks';
import clsx from 'clsx';
import NavbarButton from '../NavbarButton';
import css from '../../styles/NavbarButton.module.scss';
import {
  Container, Trigger, Content, NavbarButtonIcon,
} from './styles';
import { assetResolver } from '../../utils';
import { venuePropType } from '../../propTypes';

const FlyoutMenu = ({ venues }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isTouchDevice, setIsTouchDevice] = useState(false);
  const timeoutRef = useRef(null);

  // Detect touch device on first touch
  useEffect(() => {
    const handleTouch = () => {
      setIsTouchDevice(true);
      document.removeEventListener('touchstart', handleTouch);
    };
    document.addEventListener('touchstart', handleTouch);

    return () => {
      document.removeEventListener('touchstart', handleTouch);
    };
  }, []);

  const handleMouseEnter = () => {
    if (isTouchDevice) return;

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
    setMenuOpen(true);
  };

  const handleMouseLeave = () => {
    if (isTouchDevice) return;

    timeoutRef.current = setTimeout(() => {
      setMenuOpen(false);
    }, 200);
  };

  const onToggleClick = (e) => {
    e.stopPropagation();
    e.preventDefault();

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }

    setMenuOpen(!menuOpen);
  };

  useEffect(() => {
    if (!isTouchDevice || !menuOpen) return undefined;

    const handleOutsideClick = (e) => {
      if (!e.target.closest(`.${Container.className}`)) {
        setMenuOpen(false);
      }
    };

    document.addEventListener('click', handleOutsideClick);
    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, [menuOpen, isTouchDevice]);

  return (
    <Container onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      <Trigger onClick={onToggleClick}>
        <NavbarButton
          href="/tickets"
          className={clsx(css.NavbarButton, css.primary)}
          tabIndex={0}
          onClick={e => e.preventDefault()}
        >
          Tickets
        </NavbarButton>
      </Trigger>
      <Content active={menuOpen}>
        {venues.map(venue => (
          <NavbarButton
            venue
            href={venue.url}
            key={venue.name}
          >
            {venue.name}
            <NavbarButtonIcon
              src={assetResolver('arrow-right-blue.svg')}
              alt=""
            />
          </NavbarButton>
        ))}
      </Content>
    </Container>
  );
};

FlyoutMenu.propTypes = {
  venues: venuePropType.isRequired,
};

export default FlyoutMenu;
